import { UserProfileDto, UserRole, PaygapPersonnelDto } from "@green0meter/api-client";
import { useQuery } from "@tanstack/react-query";

import { DOMAIN_PAYGAP } from "../domain";

import { paygapApi } from "@api/services";
import { TANSTACK_QUERY_STALE_TIME } from "@constants";
import { roleGuard } from "@api";

export const ACTION_GET_CURRENT_COMPANY_PERSONNEL = "GET_CURRENT_COMPANY_PERSONNEL";

const allowedRoles = [
  UserRole.Owner,
  UserRole.Manager,
  UserRole.Respondent,
  UserRole.Viewer,
  UserRole.Auditor,
];

export const getCurrentCompanyPersonnel = async (): Promise<PaygapPersonnelDto[]> => {
  const response = await paygapApi.paygapControllerGetCurrentCompanyPersonnel();

  return response.data;
};

export const useGetCurrentCompanyPersonnel = (
  user: UserProfileDto | null,
  enabledOverride?: boolean,
): {
  personnelData: PaygapPersonnelDto[] | undefined;
  getCurrentCompanyPersonnelEnabled: boolean;
  getCurrentCompanyPersonnelError: Error | null;
  refetchGetCurrentCompanyPersonnel: () => void;
  isLoadingGetCurrentCompanyPersonnel: boolean;
  isFetchingGetCurrentCompanyPersonnel: boolean;
  isSuccessGetCurrentCompanyPersonnel: boolean;
} => {
  const roleEnabled = roleGuard(user, allowedRoles);
  const enabled = enabledOverride !== undefined ? enabledOverride : roleEnabled;
  const queryResult = useQuery<PaygapPersonnelDto[], Error>({
    queryKey: [DOMAIN_PAYGAP, ACTION_GET_CURRENT_COMPANY_PERSONNEL],
    queryFn: () => getCurrentCompanyPersonnel(),
    staleTime: TANSTACK_QUERY_STALE_TIME,
    enabled,
  });

  return {
    personnelData: queryResult.data,
    getCurrentCompanyPersonnelEnabled: enabled,
    getCurrentCompanyPersonnelError: queryResult.error,
    refetchGetCurrentCompanyPersonnel: queryResult.refetch,
    isLoadingGetCurrentCompanyPersonnel: queryResult.isLoading,
    isFetchingGetCurrentCompanyPersonnel: queryResult.isFetching,
    isSuccessGetCurrentCompanyPersonnel: queryResult.isSuccess,
  };
};
